export default __webpack_public_path__ + "static/media/work-4.ab051e85.jpg";